export default "__VITE_ASSET__Dr49ogxS__"